var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "clickoutside",
          rawName: "v-clickoutside",
          value: _vm.closeModal,
          expression: "closeModal"
        }
      ],
      staticClass: "gobierto-table__column-selector"
    },
    [
      _c(
        "div",
        {
          staticClass: "gobierto-table__column-selector__trigger",
          attrs: { "data-testid": "table-button-modal" },
          on: {
            click: function($event) {
              _vm.showColumnsModal = !_vm.showColumnsModal
            }
          }
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.labelCustomizeColumns))]),
          _vm._v(" "),
          _c("i", {
            staticClass: "gobierto-table__column-selector__icon fas fa-columns"
          })
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showColumnsModal
          ? _c(
              "div",
              {
                staticClass: "gobierto-table__column-selector__content",
                attrs: { "data-testid": "table-modal" }
              },
              _vm._l(_vm.columns, function(ref) {
                var id = ref[0]
                var ref_1 = ref[1]
                var name = ref_1.name
                var visibility = ref_1.visibility
                return _c("Checkbox", {
                  key: id,
                  attrs: { id: id, title: name, checked: visibility },
                  on: { "checkbox-change": _vm.toggleVisibility }
                })
              }),
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }